import { notifications } from '~/app/notifications'
import LoginForm from '~/themes/base/components/user/LoginForm'
import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'

export default {
  extends: LoginForm,
  methods: {
    async login() {
      if (!(await this.$validator.validate())) {
        notifications.danger(this.$validator.errors.items[0].msg)
        return
      }
      this.startLoading()
      const response = await this.$store.dispatch('auth/LOGIN', {
        email: this.input.email,
        password: this.input.password,
        redirect: this.redirectPath,
      })
      if (!response) {
        this.input.password = ''
        this.stopLoading()
      } else {
        eventBus.$emit(eventDefinitions.USER.LOGGED_IN, { user: this.$store.state.user.userData })
      }
    },
  },
}
